export const Logo = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Vamp Graphics logo">
    <polygon points="32,3 57,17.5 57,46.5 32,61 7,46.5 7,17.5" fill="none" stroke="#e2b84a" strokeWidth="2.5" />
    <polygon points="32,9 52,20.5 52,43.5 32,55 12,43.5 12,20.5" fill="none" stroke="#e2b84a" strokeOpacity=".35" strokeWidth="1" />
    <path d="M18 40 L18 23 L25 30.5 L32 18 L39 30.5 L46 23 L46 40 Z" fill="#e2b84a" />
    <circle cx="32" cy="47" r="3.6" fill="#e0263a" />
  </svg>
);

export const Wordmark = () => (
  <span className="flex items-center gap-3">
    <Logo />
    <span className="leading-none text-left">
      <span className="font-display font-bold tracking-[0.18em] text-[15px] text-gilded block">VAMP</span>
      <span className="font-mono text-[10px] tracking-[0.42em] text-[var(--ink-dim)]">GRAPHICS</span>
    </span>
  </span>
);
